/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Ben_Hard_TextInputs */

const en_funnel_ob_ben_hard_text = /** @type {(inputs: Funnel_Ob_Ben_Hard_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading can feel like the words will not sit still. The highlight follows the voice, so your eyes always know exactly where you are.`)
};

const es_funnel_ob_ben_hard_text = /** @type {(inputs: Funnel_Ob_Ben_Hard_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Al leer, a veces parece que las palabras no se quedan quietas. El resaltado sigue a la voz, así que tus ojos siempre saben exactamente dónde estás.`)
};

/**
* | output |
* | --- |
* | "Reading can feel like the words will not sit still. The highlight follows the voice, so your eyes always know exactly where you are." |
*
* @param {Funnel_Ob_Ben_Hard_TextInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_ben_hard_text = /** @type {((inputs?: Funnel_Ob_Ben_Hard_TextInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Ben_Hard_TextInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_ben_hard_text(inputs)
	return en_funnel_ob_ben_hard_text(inputs)
});